export default "__VITE_ASSET__D6_J7bjH__"